import React, { useEffect, useState } from 'react'
import { EnvelopeIcon, PhoneIcon,CheckBadgeIcon, UserIcon, CheckIcon, XCircleIcon } from '@heroicons/react/20/solid'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

function Request(props) {

    const [people, setRequests] = useState([])
    const [msg, setMsg] = useState("")
    const navigate = useNavigate()

    useEffect(() => {
        try{
            axios.get("https://dealersonly.parts/beta/api/requests")
            .then(res => {
            setRequests(res.data);
            })
            .catch((error) => {
            })
        }catch(error){
            navigate("/shop/home")
        }
    }, [msg])

    const verify = async (id) => {
        setMsg("")
        try{
        await axios.put("https://dealersonly.parts/beta/api/admin/verify", {id: id})
        .then(res => {
            setMsg(res.data)
        })}catch(error){

        }
    }

    const deleteRequest = async (id) => {
      setMsg("")
      try{
      await axios.put("https://dealersonly.parts/beta/api/admin/delete-request", {id: id})
      .then(res => {
          setMsg(res.data)
      })}catch(error){

      }
      
  }

  return (
    <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2">
        {msg &&
          <div className="rounded-md bg-green-50 p-4 mb-1 col-span-2">
          <div className="flex">
              <div className="flex-shrink-0">
              <CheckIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
              </div>
              <div className="ml-3">
              <h3 className="text-sm font-medium text-green-800">{msg}</h3>
              </div>
          </div>
          </div>
          }
      {people.length === 0 ? <div>Keine offenen Anfragen</div> :   
      people?.map((person) => (
        <li key={person._id} className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
          <div className="flex w-full items-center justify-between space-x-6 p-4">
            <div className="flex-1 truncate">
              <div className="flex items-center space-x-3">
                <h3 className="truncate text-sm font-medium text-gray-900">{person.first_name} {person.last_name}</h3>
                
              </div>
              <p className="mt-1 truncate text-sm text-gray-500">{person.businessinfo.name}</p>
              <p className="mt-1 truncate text-sm text-gray-500">{person.businessinfo?.street}</p>
              <p className="mt-1 truncate text-sm text-gray-500">{person.businessinfo?.ort}</p>
              <p className="mt-1 truncate text-sm text-gray-500">{person.businessinfo?.steuer}</p>
              <p className="mt-1 truncate text-sm text-gray-500">{person.telefon}</p>
            </div>
            <div>
                  <span
                    className='h-8 w-8 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white'>
                    <UserIcon className="h-5 w-5 text-white" aria-hidden="true" />
                  </span>
                </div>
          </div>
          <div>
            <div className="-mt-px flex divide-x divide-gray-200">
              <div className="flex w-0 flex-1">
                <button
                  type='button'
                  onClick={()=>verify(person._id)}
                  className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent py-2 text-sm font-medium text-gray-700 hover:text-gray-500"
                >
                  <CheckBadgeIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
                  <span className="ml-3">Bestätigen</span>
                </button>
              </div>
              <div className="flex w-0 flex-1">
                <button
                  type='button'
                  onClick={()=>deleteRequest(person._id)}
                  className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent py-2 text-sm font-medium text-gray-700 hover:text-gray-500"
                >
                  <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
                  <span className="ml-3">Löschen</span>
                </button>
              </div>
            </div>
          </div>
        </li>
      ))
      }
    </ul>
  )
}

export default Request